import { addMissingShape } from 'ml-gsd';
import { getShape1D } from 'ml-peak-shape-generator';
import { peaksToXY } from './peaksToXY';
export function peakToXY(peak, options) {
    const newPeak = addMissingShape([peak])[0];
    const factor = getShape1D(newPeak.shape).getFactor();
    const { from = newPeak.x - (peak.width * factor) / options.frequency, to = newPeak.x + (peak.width * factor) / options.frequency, } = options;
    return peaksToXY([peak], { ...options, from, to });
}
//# sourceMappingURL=peakToXY.js.map